
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nft/avatars",
      function () {
        return require("private-next-pages/nft/avatars/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nft/avatars"])
      });
    }
  